/**
 * Redux reducer bundle for submission form on project page
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */

/* ACTIONS
================================================================================================ */
const PARTICIPATE_FORM_CHANGE_STEP = 'crowdspring/project/PARTICIPATE_FORM_CHANGE_STEP';
const PARTICIPATE_FORM_TOGGLE = 'crowdspring/project/PARTICIPATE_FORM_TOGGLE';


/* INITIAL STATE
================================================================================================ */
const initialState = {
  formOpen: false,
  currentStep: 'intro',
};


/* HELPERS
================================================================================================ */
export const getParticipateForm = (state) => state.project.participateForm;


/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PARTICIPATE_FORM_TOGGLE:
      return Object.assign({}, state, { formOpen: !state.formOpen });
    case PARTICIPATE_FORM_CHANGE_STEP:
      const newState = Object.assign({}, state, { currentStep: action.payload });
      return newState;
    default:
      return state;
  }
}

/* ACTION CREATORS
================================================================================================ */
export function changeParticipateStep(action) {
  return {
    type: PARTICIPATE_FORM_CHANGE_STEP,
    payload: action,
  };
}

export function toggleParticipateForm(action) {
  return {
    type: PARTICIPATE_FORM_TOGGLE,
    payload: action,
  };
}



// WEBPACK FOOTER //
// ./project/ducks/form.jsx